import { gql } from "@apollo/client";

export const FETCH_WILDCARDS_USER = gql`
  query FetchWildcard {
    fetchWildcardUser {
      documentId
      startDate
      endDate
      description
      title
      ctaText
      cta {
        course {
          documentId
          slug
        }
        knowledgeBase {
          documentId
          slug
        }
        redirectToLeadershipWheel
        redirectToCalendar
      }
    }
  }
`;
